import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import AdvancedSearchHistoryComponent from './advanced-search-history-component';
import {
    changeTab,
    editFavourite,
    fetch,
    onChangeFavouriteName,
    onChangeQueryValue,
    selectQueriesByHistory,
    update,
} from './redux/action';

const mapStateToProps = (state: ApplicationState) => ({
  currentTab: state.devices.advancedSearch.history.currentTab,
  list: state.devices.advancedSearch.history.list,
  query: state.devices.advancedSearch.history.query,
  t: state.i18n.t
});

export default connect(mapStateToProps, {
  changeTab,
  fetch,
  onChangeQueryValue,
  selectQueriesByHistory,
  update,
  editFavourite,
  onChangeFavouriteName
})(AdvancedSearchHistoryComponent);
